import { forwardRef } from 'react'

import { AddressValue } from '@/lib/types/VCardT'
import { buildAddressString } from '@/lib/helpers/buildAddressString'
import LcIcon from '@/components/livecontact/icons'
import ActionItem from '@/components/ContactLinkCard/components/ActionItem'

type Props = {
  address: AddressValue
}

/**
 * Address action row: map-pin glyph, label, the full address as the detail line. Opens the
 * address in the visitor's maps app. Shares ActionItem's anatomy so it stacks with the links.
 */
const AddressLine = forwardRef<HTMLAnchorElement, Props>(({ address }, ref) => {
  const addressString = buildAddressString(address)

  if (!addressString) return null

  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressString)}`

  return (
    <ActionItem
      ref={ref}
      glyph={<LcIcon name="map-pin" />}
      title={address.label || 'Address'}
      subtitle={addressString}
      url={mapsUrl}
      isExternal
    />
  )
})

AddressLine.displayName = 'AddressLine'

export default AddressLine
